import { render, staticRenderFns } from "./PrimaryDrawer.vue?vue&type=template&id=54cc629a&"
import script from "./PrimaryDrawer.vue?vue&type=script&lang=js&"
export * from "./PrimaryDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports